import * as yup from "yup";

export const UserSetupValidationSchema = yup.object().shape({
	firstName: yup.string().required("User First Name is required"),
	lastName: yup.string().required("User Last Name is required"),
	// email: yup
	// 	.string()
	// 	.email("Must be a valid email address")
	// 	.required("User Email is required"),
	email: yup
		.string()
		.trim()
		.required("Email is required")
		.email("Must be a valid email address")
		// .matches(/\.[A-Za-z]{2,}$/, "Must be a valid email address"),
		.matches(/\.[A-Za-z]{2,}$/, {
			message: "Must be a valid email address",
			excludeEmptyString: true,
		}),
});
